import { t } from "i18next";
import { axiosGet, axiosPost } from "./AxiosAPI";

export const getPriceDollarKRW = async () => {
    return axiosGet(`api/price/dollar-krw`);
}